export enum PublishRulesCategoriesEnum {
  KNM = 'KNM',
  PLANNED_KNM = 'PLANNED_KNM',
  PLANNED_KNM_KZ = 'PLANNED_KNM_KZ',
  PLANNED_KNM_RO = 'PLANNED_KNM_RO',
  PLANNED_KNM_VK = 'PLANNED_KNM_VK',
  PLANNED_KNM_IV = 'PLANNED_KNM_IV',
  PLANNED_KNM_MZ = 'PLANNED_KNM_MZ',
  PLANNED_KNM_DP = 'PLANNED_KNM_DP',
  PLANNED_KNM_VP = 'PLANNED_KNM_VP',
  UNPLANNED_KNM = 'UNPLANNED_KNM',
  UNPLANNED_KNM_KZ = 'UNPLANNED_KNM_KZ',
  UNPLANNED_KNM_RO = 'UNPLANNED_KNM_RO',
  UNPLANNED_KNM_VK = 'UNPLANNED_KNM_VK',
  UNPLANNED_KNM_IV = 'UNPLANNED_KNM_IV',
  UNPLANNED_KNM_MZ = 'UNPLANNED_KNM_MZ',
  UNPLANNED_KNM_DP = 'UNPLANNED_KNM_DP',
  UNPLANNED_KNM_VP = 'UNPLANNED_KNM_VP',
  PM = 'PM',
  PM_PP = 'PM_PP',
  PM_OP = 'PM_OP',
  PM_CHECKS = 'PM_CHECKS',
  PLANNED_PM_CHECKS = 'PLANNED_PM_CHECKS',
  PLANNED_PM_CHECKS_VP = 'PLANNED_PM_CHECKS_VP',
  PLANNED_PM_CHECKS_DP = 'PLANNED_PM_CHECKS_DP',
  PLANNED_PM_CHECKS_KZ = 'PLANNED_PM_CHECKS_KZ',
  UNPLANNED_PM_CHECKS = 'UNPLANNED_PM_CHECKS',
  UNPLANNED_PM_CHECKS_VP = 'UNPLANNED_PM_CHECKS_VP',
  UNPLANNED_PM_CHECKS_DP = 'UNPLANNED_PM_CHECKS_DP',
  UNPLANNED_PM_CHECKS_KZ = 'UNPLANNED_PM_CHECKS_KZ',
  DECISION_PASSPORT = 'DECISION_PASSPORT',
}
